// AUTO-GENERATED by scripts/gen-build-info.js (npm prebuild hook). Do not edit by hand.
export const BUILD_INFO = {"commit":"a3249c543","time":"2026-11-04T22:00:10.079Z"} as const;
